import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { IonDatetime, ModalController, AlertController } from "@ionic/angular";
import { AuthService } from "src/app/services/auth.service";
import { EventoService } from "../../../services/evento.service";

@Component({
  selector: "app-seleccionar-fecha-entrega",
  templateUrl: "./seleccionar-fecha-entrega.component.html",
  styleUrls: ["./seleccionar-fecha-entrega.component.scss"],
})
export class SeleccionarFechaEntregaComponent implements OnInit {
  @Input() id_curso: string;
  @Input() id_libro: string;
  @Input() id_actividad: string;
  @Input() titulo: string;

  private id: number;
  private auth_key: string;
  displayUserData: any;

  timeSelected: string = null;
  dateSelected: string = null;
  current: Date = new Date();
  timeAndDateInit: string;
  timeAndDateEnd: string;
  dataResp = {
    id: null,
    fecha_hora: null,
    fecha_fin: null,
  };

  data = {
    id_curso: "",
    id_libro: "",
    id_actividad: "",
    titulo: "",
    hora_inicio: null,
    hora_fin: null,
  };

  @ViewChild("inputDate") inputDate: IonDatetime;
  @ViewChild("inputTime") inputTime: IonDatetime;

  constructor(
    private modalCtrl: ModalController,
    private authService: AuthService,
    private eventService: EventoService,
    private alertCtrl: AlertController
  ) {}

  ngOnInit() {
    this.authService.userData$.subscribe((res: any) => {
      if (!this.displayUserData) {
        this.displayUserData = res;
        this.loadVariables();
      }
    });
  }

  loadVariables() {
    this.id = this.displayUserData?.id;
    this.auth_key = this.displayUserData?.auth_key;
  }

  ionViewDidEnter() {
    console.log(this.id_curso, this.titulo, this.id_libro, this.id_actividad);
  }

  ionViewWillEnter() {
    this.findActivity();
  }

  loadData() {
    this.data.id_curso = this.id_curso;
    this.data.id_libro = this.id_libro;
    this.data.id_actividad = this.id_actividad;
    this.data.titulo = this.titulo;
    this.data.hora_inicio = this.timeAndDateInit;
    this.data.hora_fin = this.timeAndDateEnd;
  }

  createActivity() {
    this.loadData();
    //if (this.timeAndDateInit > this.current) {
      this.eventService
        .createEventActivity(this.id, this.auth_key, this.data)
        .subscribe(() => {
          this.modalCtrl.dismiss();
        });
    //} else {
      //this.presentAlert(1);
    //}
  }

  updateActivity() {
    const selectedDate = new Date(this.timeAndDateInit);
    if (selectedDate > this.current) {
      this.dataResp.fecha_hora = this.timeAndDateInit;
      this.dataResp.fecha_fin = this.timeAndDateEnd;
      this.eventService
        .updateEventActivity(this.id, this.auth_key, this.dataResp)
        .subscribe(() => {
          this.modalCtrl.dismiss();
        });
    } else {
      this.presentAlert(1);
    }
  }

  findActivity() {
    this.loadData();
    this.eventService
      .getActivityId(this.id, this.auth_key, this.data)
      .subscribe((resp) => {
        this.dataResp = resp;
        if (this.dataResp != null) {
          this.dataResp.id = resp.id;
          this.timeAndDateInit = resp.fecha_hora.replace(" ", "T");
          this.timeAndDateEnd = resp.fecha_fin.replace(" ", "T");
        }
      });
  }

  cancelar() {
    this.modalCtrl.dismiss();
  }

  async presentAlert(op) {
    if (op == 1) {
      const alert = await this.alertCtrl.create({
        header: "Alerta",
        message: "La fecha de debe ser mayor que la actual",
        buttons: ["Aceptar"],
      });
      await alert.present();
      const { role } = await alert.onDidDismiss();
    }
  }

  checkSelectedDate(event: any) {
    const today = new Date().toISOString().split('T')[0];
    const selected = event.detail.value.split('T')[0];

    if (selected === today) {
      // Restablecer la fecha seleccionada si es el día actual
      this.timeAndDateInit = '';
      alert('No se puede seleccionar el día actual.');
    }
  }
}
